/*
 * Instagram gallery modal (BRA-2011). Markup: snippets/social-gallery.liquid.
 * Nothing runs until a tile is clicked: the modal body, its images, the <video> and the product
 * cards are cloned out of <template>s on open and removed again on close.
 */
;(function () {
	"use strict"

	if (window.__socialGallery) {
		return
	}
	window.__socialGallery = true

	var open = null

	function fillProducts(gallery, body) {
		var list = body.querySelector("[data-sg-products]")
		if (list == null) {
			return
		}
		list
			.getAttribute("data-sg-products")
			.split(",")
			.filter(Boolean)
			.forEach(function (id) {
				var template = gallery.querySelector('template[data-sg-card="' + id + '"]')
				if (template == null) {
					return
				}
				// Set on the inert template copy: an <img> starts loading as soon as it's cloned.
				var images = template.content.querySelectorAll("img")
				for (var i = 0; i < images.length; i++) {
					images[i].setAttribute("loading", "lazy")
				}
				list.appendChild(document.importNode(template.content, true))
			})
	}

	function initSlides(body) {
		var slides = body.querySelector("[data-sg-slides]")
		if (slides == null) {
			return
		}
		var dots = body.querySelectorAll(".sg-dot")
		var count = slides.children.length

		function current() {
			return Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1))
		}

		function go(index) {
			var target = Math.max(0, Math.min(count - 1, index))
			slides.scrollTo({ left: target * slides.clientWidth, behavior: "smooth" })
		}

		slides.addEventListener(
			"scroll",
			function () {
				var index = current()
				for (var i = 0; i < dots.length; i++) {
					dots[i].classList.toggle("is-active", i === index)
				}
			},
			{ passive: true }
		)

		var prev = body.querySelector("[data-sg-prev]")
		var next = body.querySelector("[data-sg-next]")
		if (prev != null) {
			prev.addEventListener("click", function () {
				go(current() - 1)
			})
		}
		if (next != null) {
			next.addEventListener("click", function () {
				go(current() + 1)
			})
		}
		slides.addEventListener("keydown", function (event) {
			if (event.key === "ArrowLeft") {
				go(current() - 1)
			} else if (event.key === "ArrowRight") {
				go(current() + 1)
			}
		})
	}

	function initVideo(body) {
		var video = body.querySelector("[data-sg-video] video")
		if (video == null) {
			return
		}
		video.muted = true
		var playing = video.play()
		if (playing) {
			playing.catch(function () {
				video.controls = true
			})
		}
		var sound = body.querySelector("[data-sg-sound]")
		if (sound != null) {
			sound.addEventListener("click", function () {
				video.muted = !video.muted
				sound.setAttribute("aria-pressed", String(!video.muted))
				sound.setAttribute("aria-label", video.muted ? "Slå på lyd" : "Slå av lyd")
			})
		}
	}

	function stopVideo(body) {
		var videos = body.querySelectorAll("video")
		for (var i = 0; i < videos.length; i++) {
			var video = videos[i]
			video.pause()
			while (video.firstChild) {
				video.removeChild(video.firstChild)
			}
			video.removeAttribute("src")
			video.load()
		}
	}

	function initCaption(body) {
		var text = body.querySelector("[data-sg-caption]")
		var more = body.querySelector("[data-sg-more]")
		if (text == null || more == null) {
			return
		}
		if (text.scrollHeight > text.clientHeight + 1) {
			more.hidden = false
		}
		more.addEventListener("click", function () {
			text.classList.add("is-expanded")
			more.hidden = true
		})
	}

	function openPost(tile) {
		var gallery = tile.closest("[data-social-gallery]")
		var template = tile.closest(".sg__item").querySelector("template[data-sg-post]")
		var dialog = gallery.querySelector("dialog.sg-modal")
		if (typeof dialog.showModal !== "function") {
			// Safari before 15.4 has no <dialog>: show the post on Instagram instead.
			var permalink = tile.getAttribute("data-sg-permalink")
			if (permalink) {
				window.open(permalink, "_blank", "noopener")
			}
			return
		}

		var body = dialog.querySelector("[data-sg-body]")
		body.appendChild(document.importNode(template.content, true))
		fillProducts(gallery, body)

		open = { dialog: dialog, body: body, tile: tile, pushed: false }
		dialog.showModal()
		document.documentElement.classList.add("sg-lock")
		dialog.querySelector("[data-sg-close]").focus({ preventScroll: true })

		try {
			history.pushState({ socialGallery: true }, "")
			open.pushed = true
		} catch (e) {}

		initSlides(body)
		initVideo(body)
		initCaption(body)
	}

	// Every way out ends here: X and backdrop call dialog.close(), Escape closes the dialog
	// natively, and Back arrives through popstate (fromHistory).
	function close(fromHistory) {
		if (open == null) {
			return
		}
		var current = open
		open = null
		stopVideo(current.body)
		if (current.dialog.open) {
			current.dialog.close()
		}
		current.body.innerHTML = ""
		document.documentElement.classList.remove("sg-lock")
		current.tile.focus({ preventScroll: true })
		if (current.pushed && !fromHistory) {
			history.back()
		}
	}

	document.addEventListener("click", function (event) {
		var target = event.target
		if (!(target instanceof Element)) {
			return
		}
		var tile = target.closest("[data-sg-open]")
		if (tile != null) {
			event.preventDefault()
			openPost(tile)
			return
		}
		if (open == null) {
			return
		}
		var link = target.closest("a[href]")
		if (
			link != null &&
			open.pushed &&
			link.target !== "_blank" &&
			link.origin === location.origin &&
			!event.defaultPrevented &&
			event.button === 0 &&
			!(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
		) {
			// Leave through the modal's own history entry, so Back returns to this page once.
			event.preventDefault()
			location.replace(link.href)
			return
		}
		if (target.closest("[data-sg-close]") != null || target === open.dialog) {
			close(false)
		}
	})

	document.addEventListener(
		"close",
		function (event) {
			if (open != null && event.target === open.dialog) {
				close(false)
			}
		},
		true
	)

	window.addEventListener("popstate", function () {
		close(true)
	})
})()
